import { tv } from "@fanka/tailwind-variants";
import clsx from "clsx";

export const RADIO_ITEM_CLASS_NAME = tv({
  base: clsx(
    "bg-ui-white border-ui-200 h-[16px] w-[16px] cursor-default rounded-full border outline-none",
    // disabled
    "disabled:cursor-not-allowed disabled:bg-ui-100 disabled:border-ui-200  disabled:text-base-disabled",
  ),
  variants: {
    error: {
      true: "border-functional-danger",
    },
    activeDisabled: {
      true: "disabled:bg-ui-white",
    },
  },
});

export const RADIO_INDICATOR_CLASS_NAME = tv({
  base: clsx(
    "after:bg-ui-500 relative flex h-full w-full items-center justify-center after:block after:h-[10px] after:w-[10px] after:rounded-[50%] after:content-['']",
    // disabled
    "disabled:cursor-not-allowed disabled:text-base-disabled",
  ),
  variants: {
    error: {
      true: "border-functional-danger after:bg-functional-danger",
    },
    disabled: {
      true: "after:bg-ui-300",
    },
  },
});
